import { type OptimizelyDecision } from '@optimizely/optimizely-sdk'

export const FEATURE_FLAG = {
  CLIENT_SIDE_SRP_LOAD: 'kcan-22967_client_side_srp_load',
  CHAMELEON_TRACKING: 'chameleon_tracking',
  PERFORMANCE_LISTING_COUNT: 'kcan_23226_performance_listing_count_toggle',
  REGISTRATION_LEGAL_UPDATES: 'registration_legal_updates',
  CAS_BACKFILL_REDUCTION: 'kcan-22549_reduce_admarkt_backfill',
  SUPPORT_NEW_SCHEMA_FOR_TOGGLES_FILTER: 'support_new_schema_for_toggles_filters',
  SEARCH_AROUND_ME_EXP: 'kjca-913-allow-users-to-search-nearby-radius',
  PRICE_DROP_NOTIFICATION: 'price_drop_notification',
  HEADER_SIMPLIFIED: 'header_simplified_v2',
  AUTOS_LANDING_PAGE_EXPERIMENT: 'kjca-1941-autos-landing-page-experiment',
  SRP_QUICK_FILTERS_PILLS: 'srp_quick_filters_pills',
  SAVED_SEARCH_WITHIN_FILTERS: 'kjca-3630-saved-search-within-filters',
} as const

export type RuleDecision = {
  isEnabled?: OptimizelyDecision['enabled']
  variationKey: OptimizelyDecision['variationKey']
}

export type FeatureFlag = ValuesType<typeof FEATURE_FLAG>
